export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utwórz prośbę o pomoc"])}
}